import { createFilledIcon } from "../createIcon";

export const CalendarFilledIcon = createFilledIcon(
  <>
    <path d="M18.787 3.399c0-.552-.432-1-.965-1-.532 0-.964.448-.964 1V4.73H7.75V3.4c0-.552-.432-.999-.964-.999-.533 0-.965.447-.965.999V4.73c-1.42 0-2.571 1.193-2.571 2.664v11.541c0 1.471 1.151 2.664 2.571 2.664H18.68c1.42 0 2.571-1.193 2.571-2.664V7.395c0-1.434-1.093-2.603-2.463-2.661V3.399Zm-12.644 6.66c0-.552.432-1 .964-1h10.714c.533 0 .965.448.965 1 0 .55-.432.998-.965.998H7.107c-.532 0-.964-.447-.964-.999Z" />
  </>,
  "CalendarFilledIcon"
);
